import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService } from '@lib/auth/auth.service';

export function gcomMatchGuard(gcomRoute: boolean): CanMatchFn {
  return () => {
    const authService = inject(AuthService);

    return (
      (authService.isOnlyGcom() && gcomRoute) || (!authService.isOnlyGcom() && !gcomRoute)
    );
  };
}
